import { createContext, ReactNode, useContext } from "react";
import { useApi } from "../app/ApiContext";
import { LEAGUE_ID } from "../app/config";
import { GameweekData, useGameweek } from "./useGameweek";

const GameweekContext = createContext<GameweekData | null>(null);

/** Loads the gameweek once for the whole shell so list and detail screens share it. */
export const GameweekProvider = ({ children }: { children: ReactNode }) => {
	const api = useApi();
	const data = useGameweek(api, LEAGUE_ID);
	return <GameweekContext.Provider value={data}>{children}</GameweekContext.Provider>;
};

export const useGameweekContext = (): GameweekData => {
	const data = useContext(GameweekContext);
	if (data == null) {
		throw new Error("useGameweekContext must be used inside a GameweekProvider");
	}
	return data;
};
